/* tslint:disable */

import { OrganisationDto } from './OrganisationDto';
import { UserDto } from './UserDto';

export class PublicLinkDto {
  id?: string;
  guidelineUniqueId?: string;
  link?: string;
  createdById?: string;
  createdBy?: UserDto;
  createdAt?: any;
  organisationId?: string;
  organisation?: OrganisationDto;
  expiryDate?: Date | null;
  guidelineOwner?: UserDto;
  guidelineCreatedAt?: Date | null;
  guidelineTitle?: string;
  isDeactivated?: boolean;
}
